import { render, staticRenderFns } from "./evaluacion.vue?vue&type=template&id=06c3f4ea&"
import script from "./evaluacion.vue?vue&type=script&lang=js&"
export * from "./evaluacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports